class EyeFollower {
    constructor() {
        this.eyes = document.querySelectorAll('.eyes .eye');
        if (!this.eyes.length) return;

        this.rangeYOffset = { min: -18, max: 0 };
        this.rangeXOffset = { min: -2, max: 3 };
        this.maxDistance = 200;

        window.addEventListener('mousemove', ({ pageX, pageY }) => {
            this.eyes.forEach((eye) => {
                this.follow(eye, { pageX, pageY });
            });
        });
    }

    follow(eye, coords) {
        const { pageX, pageY } = coords;
        const { x, y } = eye.getBoundingClientRect();
        const {
            maxDistance,
            rangeXOffset: { min: minX, max: maxX },
            rangeYOffset: { min: minY, max: maxY },
        } = this;

        const deltaX = pageX - x;
        const deltaY = pageY - y;

        const transform = {};

        if (deltaY <= -maxDistance) transform.y = minY;
        else if (deltaY >= maxDistance) transform.y = maxY;
        else {
            const range = 2 * maxDistance;
            const position = deltaY + maxDistance;
            const pc = 100 - (position * 100) / range;
            const YRange = minY - maxY;
            transform.y = (pc * YRange) / 100;
        }
        if (deltaX <= -maxDistance) transform.x = minX;
        else if (deltaX >= maxDistance) transform.x = maxX;
        else {
            const range = 2 * maxDistance;
            const position = deltaX + maxDistance;
            const pc = (position * 100) / range;
            const XRange = minX - maxX;
            transform.x = -((pc * XRange) / 100) + minX;
        }

        // eslint-disable-next-line
        eye.style.transform = `translate(${transform.x}px ,${transform.y}px)`;
    }
}

export default EyeFollower;
